module.exports = __webpack_public_path__ + "static/media/16UNODC18.a102a73b.jpg";